import { useI18n } from '@change-corgi/core-react/i18n';

import { useContributionsPageState } from '#src/app/pages/accountSettings/contributions/main/pageContext';

type ButtonAmount = {
	value: string;
	label: string;
};

export function useButtonAmounts(): ButtonAmount[] {
	const [
		{
			subscription: {
				config: { amountChoices },
				currencyCode,
			},
		},
	] = useContributionsPageState();
	const { localizeCurrency } = useI18n();

	return amountChoices.map((amount) => ({
		value: `${amount}`,
		label: localizeCurrency(amount, currencyCode),
	}));
}
